import { render, staticRenderFns } from "./VModalChangeName.vue?vue&type=template&id=7b9697e2&scoped=true&"
import script from "./VModalChangeName.vue?vue&type=script&lang=js&"
export * from "./VModalChangeName.vue?vue&type=script&lang=js&"
import style0 from "./VModalChangeName.vue?vue&type=style&index=0&id=7b9697e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9697e2",
  null
  
)

export default component.exports